export const _throw = (data) => {
  return {
    error: true,
    ...data
  }
}